import React from 'react'
import { assoc, compose, pick } from 'ramda'
import { capitalizeAllIfLower } from '@btime/helpers'

import { cache } from '../apollo/api'
import { initSessionVars, destroySessionVars, getSessionVars } from './sessionStorage'
import { useBtimeLogger } from '../logger/btimeLogs/log'

export const sessionConfig = {
  useOnLogin: () => {
    const btLogger = useBtimeLogger()

    return data => {
      initSessionVars(data)

      const user = compose(pick(['id', 'name', 'email']), item =>
        assoc('name', capitalizeAllIfLower(item?.name || ''), item)
      )(data?.user || {})

      btLogger.info({
        name: 'login',
        data: { user },
        user
      })
    }
  },

  useOnLoadSession: () => {
    return data => {}
  },

  useOnLogout: () => {
    const btLogger = useBtimeLogger()

    return () => {
      btLogger.info({ name: 'logout' })
      cache.reset()
      window.Gleap.clearIdentity()
      destroySessionVars()
    }
  },

  useSessionLocalStorage: () => {
    const storageRef = React.useRef(getSessionVars())
    return [storageRef.current, false]
  }
}
